import React, {useState, useEffect} from "react";

import { graphql } from 'gatsby';
import { ThemeProvider } from 'styled-components'
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import { MenuItem } from '@material-ui/core';


import Link from "../components/Link";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import RightContainer from "../components/RightContainer";
import MUIDrawer from "../components/Drawer";
import YearFilterHeader from "../components/YearFilterHeader";
import {MenuContext} from '../components/PostUtils';

import theme from "../theme.js";

export const query = graphql`
query SITE_ARCHIVE_QUERY {
  site {
    siteMetadata {
      title
      description
      url
    }
  }
  allMarkdownRemark(
    sort: {fields: [frontmatter___date], order: DESC}
    filter: {frontmatter: {ispublished: {nin: false}, ispage: {nin: true}}}
  ) {
    nodes {
      id
      excerpt(pruneLength: 400)
      frontmatter {
        title
        date(formatString: "YYYY-MM-DD")
        slug
        tags
      }
    }
  }
}
`;


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    //padding: theme.spacing(1),
    display: "flex",
    justifyContent: "center",
  },
  container: {
    flexGrow: 1,
  },
  grid: {
    height: "100vh",
  },

  topgrid: {
    marginTop: "10px",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  drawerPaper: {
    width: '100%',
  },
  listItemTextPrimary: {
    color: 'red',
  },
  listItemTextSecondary: {
    color: 'green',
  },
}));

const ContainerDiv = styled.div`
  flex-grow: 1;
  padding-left: 35px;
  padding-right: 35px;
  background: #FAF9F7;

  ${props => props.theme.breakpoints.between("sm", "xl")} {
    padding-left: 20px;
    padding-right: 20px;
  }
  ${props => props.theme.breakpoints.up("xl")} {
    max-width: 1000px;
    margin: 0 auto;
  }
  ${props => props.theme.breakpoints.down("xs")} {
    padding-left: 0px;
    padding-right: 0px;
  }

`;

const PostContainer = styled.div`
  margin-right: auto;
  margin-left: auto;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 4rem;
  max-width: 1000px;
  width: 100%;
  padding: 0;
 
  ${props => props.theme.breakpoints.down("xs")} {
    margin-top: 1rem; 
    margin-right: 0;
    margin-left: 0;
    padding: 0;
    min-height: auto;
    min-width: auto;
  }
`;

const ArchivePostListItem = styled(ListItem)`
 
  & .myprimary {
    font-family: Old Standard TT, serif;
    font-weight: bold;
    font-size: 2rem;
    color: #4c494f;
    line-height: 1.25;
    letter-spacing: -0.02em;
    font-feature-settings: "liga", "kern";
  }  
  
  & p.mysecondary {
    font-family: Lora, serif;
    color: #333;
    line-height: 1.75;
  }

  &:hover {
    text-decoration: none;
  }
 
`;

const ArchivePostListItemText = styled(ListItemText)`

  ${props => props.theme.breakpoints.down("xs")} {
      font-size: 1.5em;
    font-weight: bold;

    & .MuiListItemText-primary {
      font-size: 1.3rem;
    }
    & .MuiListItemText-secondary {
      font-size: 0.9rem;
    }
  }

`;

const ArchivePostDate = styled.div`
  display: flex;
  flex-direction: 1;
  color: #AD5843;
  font-family: Open Sans, sans-serif;
  font-size: 0.85rem;
  font-weight: 500;
  font-variant: small-caps;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
`;
const ContentDiv = styled.div`
  flex: 1;
  max-width: 700px;
  
  ${props => props.theme.breakpoints.down("xs")} {
    max-width: 100%;
    width: 100%;
  }
`;

const PageTitle = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

const ArchiveStyledPostLink = styled(Link)`
  font-family: Old Standard TT, serif;
  font-weight: bold;
  color: #AD5843;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1em;
  text-decoration: none;
  
  &:hover {
    text-decoration: none;
    opacity: 0.8;
  }
`;

const StyledLink = styled.a`
  color: #4c494f;
  font-style: italic;
`;
const StyledTypography = styled(Typography)`
   margin-bottom: 1rem;
   font-family: Lora,sans serif;

`;


export default function Archive({ data }) {
  const classes = useStyles(theme);
  // Keep the burger menu closed when it first starts
  const [isOpen, setIsOpen] = useState(false);
  return (

    <Layout>
      <MenuContext.Provider value={{isOpen: isOpen, setIsOpen: setIsOpen}}>
        <Hidden smUp>
          <MUIDrawer/>
        </Hidden>
        <Seo
          title="Archive"
          description="An archive of Viksit Gaur's writing about AI, software, technology, and institutions."
          pathname="/archive/"
        />
        <ThemeProvider theme={theme}>
          <ContainerDiv>
            <PostContainer>
              <Hidden smUp>
                <RightContainer/>
              </Hidden>
              
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '3rem', width: '100%' }}>
                <ContentDiv>
                  <PageTitle>Writing archive</PageTitle>
                  <YearFilterHeader posts={data.allMarkdownRemark.nodes} />
                  <List component="div" dense={true}>
                    {
                      data.allMarkdownRemark.nodes.map(({ excerpt, frontmatter }) => {
                        return (
                          <ArchivePostListItem
                            key={frontmatter.slug}
                            component={ArchiveStyledPostLink}
                            to={frontmatter.slug}
                          >
                            <ArchivePostDate>
                              {frontmatter.date}
                            </ArchivePostDate>
                            <ArchivePostListItemText
                              primary={frontmatter.title}
                              secondary={excerpt}
                              classes={{
                                secondary: 'mysecondary',
                                primary: 'myprimary',
                              }}
                            />
                          </ArchivePostListItem>
                        );
                      })
                    }
                  </List>
                </ContentDiv>
                
                <Hidden xsDown>
                  <div style={{ flexShrink: 0, width: '200px' }}>
                    <RightContainer/>
                  </div>
                </Hidden>
              </div>
            </PostContainer>
          </ContainerDiv>
        </ThemeProvider>
      </MenuContext.Provider>
    </Layout>
  );
}
